<template>
  <div>
    <general-table
      :api-url="apiUrl"
      :add-component-name="addComponentName"
      :edit-component="editComponent"
      :delete-content="false"
      :block-content="false"
      :edit-content="true"
      :view-content="true"
      :add-type="addType"
      :viw-component="'show-delegator'"
      :columns="filteredColumns"
      :type="type"
    >
      <template #cell(signature)="data">
        <div>
          <b-img
            width="64"
            :src="data.item.signature"
          />
        </div>
      </template>
      <template #cell(stamp)="data">
        <b-img
          width="64"
          :src="data.item.stamp"
        />
      </template>
      <template #cell(auto_proceed)="data">
        <slot
          name="show"
          v-bind="data"
        >
          <div
            v-b-popover.hover.topright="'+ add auto proceed'"
            style="padding: 2px 0px;"
            class="hover-pointer"
          >
            <span
              v-if="data.item.auto_proceed === 1"
              @click="AddAutoProceed(data.item.id)"
            >
              <feather-icon
                icon="CheckIcon"
                size="25"
                color="success"
              />
            </span>
            <span
              v-else
              @click="AddAutoProceed(data.item.id)"
            >
              <feather-icon
                icon="XIcon"
                size="20"
                color="red"
              />
            </span>
          </div>
        </slot>
      </template>
      <template #cell(offer)="data">
        <slot
          name="show"
          v-bind="data"
        >
          <div
            v-b-popover.hover.topright="'+ add offer'"
            class="hover-pointer"
            @click="
              $router.push({
                name: 'add-offer-delegator',
                params: { id: data.item.id }
              })
            "
          >
            <span
              v-if="data.item.offer"
            >
              {{ data.item.offer.name }} - {{ data.item.offer.amount }} %
            </span>
          </div>
        </slot>
      </template>
      <template #cell(wallet_balance)="data">
        <slot
          name="show"
          v-bind="data"
        >
          <div
            v-b-popover.hover.topright="'+ add wallet balance'"
            class="hover-pointer"
            @click="
              $router.push({
                name: 'add-balance',
                params: { id: data.item.id }
              })
            "
          >
            <span
              v-if="data.item.wallet_balance"
            >
              {{ data.item.wallet_balance }}  {{ data.item.wallet_currency }}
            </span>
          </div>
        </slot>
      </template>
    </general-table>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {
  components: { GeneralTable },
  data() {
    return {
      addComponentName: '',
      editComponent: 'edit-delegator',
      addType: '',
      viewContent: 'show-delegator',
      type: 'page',
      filter: {},
      loading: false,
      delegatorRole: '',
      columns: [
        { key: 'signature', label: 'signature' },
        { key: 'stamp', label: 'stamp' },
        { key: 'name', label: 'Name' },
        { key: 'email', label: 'Email' },
        { key: 'phone', label: 'Phone' },
        { key: 'offer', label: 'Offer' },
        { key: 'wallet_balance', label: 'Wallet Balance' },
        { key: 'nearest_certificate', label: 'Nearest Certificate' },
        { key: 'auto_proceed', label: 'Auto Proceed' },
        { key: 'last_request_date', label: 'Last Request Date' },
        { key: 'actions' },
      ],
    }
  },
  computed: {
    ...mapState({
      role: state => state.login.role,
    }),
    filteredColumns() {
      if (this.role === 'super-accountant' || this.role === 'accountant') {
        return this.columns.filter(column => [
          'name',
          'email',
          'phone',
          'offer',
          'wallet_balance',
          'auto_proceed',
          'view_details',
          'add_auto_proceed',
          'add_balance',
        ].includes(column.key))
      }
      if (this.role === 'markter') {
        return this.columns.filter(column => [
          'name',
          'email',
          'phone',
          'offer',
          'wallet_balance',
          'auto_proceed',
          'view_details',
          'add_offer',
        ].includes(column.key))
      }
      return this.columns
    },
    apiUrl() {
      const base = 'delegator/signed?'
      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      const queryParams = Object.entries(this.filter)
        .filter(([key, value]) => key && value)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')

      return `${base}${queryParams}`
    },
  },
  mounted() {
    this.delegatorRole = this.role
  },
  methods: {
    AddAutoProceed(id) {
      this.$swal({
        title: 'Auto proceed Requests?',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'YES',
        cancelButtonText: 'NO',
      })
        .then(result => {
          if (result.isConfirmed) {
            axios
              .post(`delegator/${id}/auto-proceed`, {
                _method: 'PUT',
                auto_proceed: 1,
              })
              .then(() => {
                window.location.reload()
              })
              .finally(() => {
                this.loading = false
              })
          } else if (result.dismiss === 'cancel') {
            axios
              .post(`delegator/${id}/auto-proceed`, {
                _method: 'PUT',
                auto_proceed: 0,
              })
              .then(() => {
                window.location.reload()
              })
              .finally(() => {
                this.loading = false
              })
          }
        })
    },
    filterTypes(type) {
      this.types = this.status.filter(item => item.text !== type)
    },
  },
}
</script>
